import * as PIXI from "pixi.js";
import {TweenMax, Linear, TimelineMax} from "gsap";
import Animation from "Engine/base/animation/Animation";
import Utils from "Engine/Utils";
import EntryPoint from "Engine/EntryPoint";
import SoundManager from "Engine/soundManager/SoundManager";

export default class WildSymbol extends PIXI.Container {
    constructor(data) {
        super();

        this._oldData = null;
        this._data = null;
        this._animation = null;

        this.init();
        this.createTweens();
        this.data = data;
    }

    init() {
        this._animation = new Animation('symbol_2_spine');
        this.animation.on('complete', this.onAnimationComplete, this);
        this.animation.x = 246 / 2;
        this.animation.y = 246 / 2;
        this.addChild(this.animation);
        //this.animation.on('skinchange', this.onChangeLockSkin, this);
    }

    createTweens() {
        this.flyDownTween = new TimelineMax({onComplete: this.destroy, callbackScope: this, paused: true});
        this.flyDownTween.to(this, 0.5, {y: -246, ease: Linear.easeNone});
        this.flyDownTween.to(this, 1, {
            y: 1000,
            /*x: '+=' + Utils.getRandomInt(-246, 246),*/
            alpha: 0,
            ease: Linear.easeNone,
            delay: 0.7
        });
    }

    play(name, loop = false) {
        this.animation.play(loop, name);
    }

    changeSkin(name) {
        this.animation.changeSkin(name);
    }

    onAnimationComplete(animation) {
        switch (this.animation.animationName) {
            case 'appear':
                if (this.multiplier > 1) {
                    this.changeSkin('x' + this.multiplier);
                    this.play('multiplier_in');
                    SoundManager.play('sounds/mainGame/WildMultiplier', 1, false);
                }

                if (this.lockCount > 0) {
                    this.changeSkin('lock' + this.lockCount);
                    this.play('lock_in');
                    SoundManager.play('sounds/mainGame/WildLock', 1, false);
                }
                break;
            case 'falling_in':
                this.play('falling_idle', true);
                break;
            case 'lock_out':
                this.changeSkin('default');
                break;
            case 'flight':
                if (this.pos.y < 1) {
                    this.play('falling_in');
                }
                break;
        }
    }

    onChangeLockSkin(animation) {

    }

    updatePosition() {
        if (this._oldData.wildCoordinates && this._data.wildCoordinates.y === this._oldData.wildCoordinates.y) {
            return;
        }
        let reelsOffset = EntryPoint.GameModel.isFreeSpins ? 7 : 6;
        this.x = (this.pos.x - 1) * (246 + reelsOffset);
        this.y = (this.pos.y - 1) * 246;
    }

    decreaseLockCount() {
        this._data.remainingStickyRounds--;
        this.updateLock();
    }

    updateLock() {
        if (this._data.remainingStickyRounds !== this._oldData.remainingStickyRounds) {
            if (this.lockCount > 0) {
                this.play('lock_skin_change');
                setTimeout(() => {
                    this.changeSkin('lock' + this.lockCount);
                }, 400)
            } else {
                this.play('lock_out');
            }
            SoundManager.play('sounds/mainGame/WildLock', 1, false);
        }

        /*if (this.lockCount > 0) {
            this.changeSkin('lock' + this.lockCount);
        } else {
            this.changeSkin('default');
        }*/
    }

    flyUp() {
        this._data.wildCoordinates.y--;
        this.play('flight');
        TweenMax.to(this, 0.5, {y: (this.pos.y - 1) * 246, ease: Linear.easeNone, delay: 0.3});
        SoundManager.play('sounds/mainGame/WildFlying', 1, false);
    }

    flyDown() {
        this._data.wildCoordinates.y--;
        this.play('flight');
        SoundManager.play('sounds/mainGame/WildFlying', 1, false);
        this.flyDownTween.play(0);
    }

    destroy(options) {
        this.flyDownTween.pause();
        super.destroy(options);
    }

    get data() {
        return this._data;
    }

    set data(value) {
        this._oldData = Object.assign({}, this._data);
        this._data = value;
        this.updatePosition();
        this.updateLock();
    }

    get pos() {
        return this.data.wildCoordinates;
    }

    get lockCount() {
        return this.data.remainingStickyRounds;
    }

    get multiplier() {
        return this.data.multiplier;
    }

    get type() {
        return this.data.featureType;
    }

    get animation() {
        return this._animation;
    }
}